import * as station from '../actions/stationQueryAction'

const initialState = {
    stations: [],
    error: undefined,
    status: 0
};

const stationList = (state = initialState, action) => {
    switch (action.type) {
        case station.STATION_LIST_REQUEST:
            return ({
                ...state,
                status: 1
            });
        case station.STATION_LIST_SUCCESS:
            return ({
                stations: action.stationList,
                error: undefined,
                status: 2
            });
        case station.STATION_LIST_FAILURE:
            return ({
                stations: [],
                error: action.error,
                status: 3
            });
        default:
            return state;
    };
}

export default stationList;
